import PropTypes from "prop-types"
import React, { useContext } from "react"

import Button from "src/components/Button"
import Heading from "src/components/Heading"

import { SignContractWizardContext } from "../../SignContractWizardContext"
import SubmitFailureNotice from "./SubmitFailureNotice"

const SubmitAgreement = ({ isSubmitting }) => {
  const { dispatch, state, steps, wizardCopy } = useContext(
    SignContractWizardContext
  )
  const { submitFailure } = state

  const goToStep = (key) =>
    dispatch({
      type: "SET_CURRENT_STEP",
      payload: steps.findIndex((step) => step.key === key) + 1,
    })

  // One persistent live region: swapping its children announces the change
  // from sending to failed; replacing the region itself would announce nothing.
  return (
    <div role="status" aria-live="polite" className="mx-auto max-w-xl">
      {submitFailure ? (
        <div className="flex flex-col space-y-6">
          <Heading.PageTitle>{wizardCopy.submitFailedTitle}</Heading.PageTitle>
          <SubmitFailureNotice
            failure={submitFailure}
            copy={{
              callMarina: wizardCopy.callMarina,
              backToPaymentMethod: wizardCopy.backToPaymentMethod,
              backToAdditionalInformation:
                wizardCopy.backToAdditionalInformation,
            }}
            onBackToPayment={() => goToStep("pay")}
            onBackToAdditionalInformation={() => goToStep("additional")}
          />
          {!submitFailure.terminal && (
            <Button
              variant="primary"
              type="submit"
              fullWidth
              isLoading={isSubmitting}
            >
              {wizardCopy.tryAgain}
            </Button>
          )}
        </div>
      ) : (
        <div className="flex flex-col items-center py-16 text-center">
          <i
            aria-hidden="true"
            className="fa-solid fa-spinner-third fa-spin mb-6 text-[40px] text-blue-700"
          />
          <Heading.PageTitle>{wizardCopy.submittingTitle}</Heading.PageTitle>
          <p className="mb-0 mt-2 text-base text-gray-700">
            {wizardCopy.submittingSubtitle}
          </p>
        </div>
      )}
    </div>
  )
}

SubmitAgreement.propTypes = {
  isSubmitting: PropTypes.bool,
}

export default SubmitAgreement
